var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"200px","height":"200px"}},[_c('canvas',{attrs:{"id":"myChart2","width":"200","height":"200"}})])}]

export { render, staticRenderFns }